export type ClassValue = string | false;

export const classNames = (...classes: readonly ClassValue[]): string =>
  classes.filter((className): className is string => Boolean(className)).join(' ');
